import React from "react";
import Client1 from "../../Images/client-1(e&c).png";
import Client2 from "../../Images/client-2(e&c).png";
import Client3 from "../../Images/client3(e&c).png";
import Client4 from "../../Images/client4(e&c).png";
import Client5 from "../../Images/client5(e&c).png";
import Grouped from "../../Images/cients-grouped(e&c).png";
import tick from "../../Images/tick-event&conf.svg";
import { useNavigate } from "react-router-dom";

const OurHappyClientsSection = () => {
  const navigate = useNavigate();

   const handleAboutUs = () => {
    navigate("/about-us");
  };
  const clientLogos = [Client1, Client2, Client3, Client4, Client5];

  return (
    <div
      className="py-16 px-6 overflow-hidden"
      style={{ backgroundColor: "#c99c48" }}
    >
      <div className="" data-aos="fade-up">
        <div className="py-8">
          <div className="text-white text-sm font-light text-center mb-8">
            A Company Mix Can Make The Difference
          </div>
          <div className="text-white text-4xl font-bold text-center mb-8">
            Our Happy Clients
          </div>
        </div>

        <div className="relative overflow-hidden">
          <div
            className="flex animate-scroll-logos whitespace-nowrap"
            data-aos="fade-up"
          >
            {/* First set of logos */}
            {clientLogos.map((logoPath, index) => (
              <div
                key={`first-${index}`}
                className="inline-flex items-center justify-center mx-12 flex-shrink-0"
                style={{ width: "200px" }}
              >
                <img
                  src={logoPath}
                  alt={`Client logo ${index + 1}`}
                  className="h-10 w-auto object-contain filter brightness-0 invert"
                />
              </div>
            ))}
            {/* Duplicate set for seamless loop */}
            {clientLogos.map((logoPath, index) => (
              <div
                key={`second-${index}`}
                className="inline-flex items-center justify-center mx-12 flex-shrink-0"
                style={{ width: "200px" }}
              >
                <img
                  src={logoPath}
                  alt={`Client logo ${index + 1}`}
                  className="h-10 w-auto object-contain filter brightness-0 invert"
                />
              </div>
            ))}
            {/* Third set for seamless loop */}
            {clientLogos.map((logoPath, index) => (
              <div
                key={`third-${index}`}
                className="inline-flex items-center justify-center mx-12 flex-shrink-0"
                style={{ width: "200px" }}
              >
                <img
                  src={logoPath}
                  alt={`Client logo ${index + 1}`}
                  className="h-10 w-auto object-contain filter brightness-0 invert"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-7xl mx-auto py-32" data-aos="fade-up">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-black">
            <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
              Over 25+ Year Of
              <br />
              Experience In Saudi
              <br />
              Market
            </h1>

            <p className="text-lg mb-8 opacity-90 leading-relaxed">
              With 25+ years of experience, we are happy to express that our
              expertise management development. We have an established record of
              delivering superior service and customer satisfaction
            </p>

            {/* Feature Points */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <img src={tick} alt="tick" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">High Quality Work</h3>
                  <p className="text-sm opacity-80">
                    We are committed to excellence and customer focused approach
                    to deliver best quality
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="w-6 h-6 rounded-full flex items-center justify-center mr-3 mt-1 flex-shrink-0">
                  <img src={tick} alt="tick" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Qualified team</h3>
                  <p className="text-sm opacity-80">
                    Our team consists of qualified and experienced professionals
                    ready to serve
                  </p>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <button className="bg-black text-white font-medium py-3 px-8 rounded-lg transition-all duration-300 transform hover:scale-105 active:scale-95 flex items-center space-x-2 "
             onClick={handleAboutUs}
            >
              More About Us
            </button>
          </div>

          {/* Right Image Section */}
          <div className="relative flex justify-center lg:justify-end">
            {/* Container for the combined 3 images */}
            <div className="relative">
              <div className="relative w-80 h-80">
                {/* Use the imported grouped image */}
                <img
                  src={Grouped}
                  alt="Team members working"
                  className="w-full h-full object-cover"
                />

                {/* Decorative dots */}
                <div className="absolute -top-4 -right-4 w-3 h-3 bg-white rounded-full"></div>
                <div className="absolute top-1/4 -right-8 w-2 h-2 bg-white rounded-full"></div>
                <div className="absolute bottom-1/4 -left-6 w-4 h-4 bg-white rounded-full"></div>
                <div className="absolute -bottom-2 right-1/4 w-2 h-2 bg-white rounded-full"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes scroll-logos {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-1000px);
          }
        }

        .animate-scroll-logos {
          animation: scroll-logos 15s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default OurHappyClientsSection;
